import { NotFoundRoute } from '@issuemanager/apps/client/components';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorPage } from '../error';
import Home from '../home';
import IssuesHome from '../issue';
import IssueTemplateForm from '../issue-template/form/issue-template-form';
import ListIssueTemplates from '../issue-template/issue-templates';
import ManageIssue from '../issue/manage-issue';
import MasterIssues from '../issue/master-issue';
import { CreateIssue } from '../issue/new-issue';
import Relationships from '../issue/relationships';
import SettingsHome from '../settings';
import IssueTypes from '../settings/issue-types';
import IssueTypeForm from '../settings/issue-types/issue-type-form';
import ListSLAs from '../settings/sla';
import SharedComponentsTest from '../shared-components-test';
import ViewIssue from '../view-issue';
import { paths } from './paths';
import {
  AdminOrTypeManagerRoute,
  AdminRoute,
  FeatureFlagRoute,
  TypeManagerRoute,
} from './protected-route';

export default function () {
  return (
    <Routes>
      <Route path={`/${paths.issues.create}`} element={<CreateIssue />} />

      <Route path='/' element={<Home />}>
        <Route
          index
          element={<Navigate to={`${paths.issues.master}`} replace />}
        />
        <Route path={`/${paths.issues.master}`} element={<MasterIssues />} />
      </Route>
      <Route path={`/${paths.issues.index}`} element={<IssuesHome />}>
        <Route path=':code' element={<ViewIssue />} />
        <Route
          path={`:code/${paths.issues.manage}`}
          element={<ManageIssue />}
        />
        <Route
          path={`:code/${paths.issues.relationships}`}
          element={<Relationships />}
        />
      </Route>
      <Route
        element={
          <AdminOrTypeManagerRoute redirectPath={`/${paths.issues.master}`} />
        }
      >
        <Route path={`/${paths.settings.index}`} element={<SettingsHome />}>
          <Route
            path={`${paths.issueTypes.index}`}
            element={
              <AdminRoute
                redirectPath={`/${paths.settings.index}/${paths.issueTemplates.index}`}
              />
            }
          >
            <Route index element={<IssueTypes />} />
          </Route>
          <Route
            path={paths.issueTemplates.index}
            element={
              <TypeManagerRoute redirectPath={`/${paths.issues.master}`} />
            }
          >
            <Route index element={<ListIssueTemplates />} />
          </Route>
          <Route
            path={paths.slaConfiguration.index}
            element={
              <TypeManagerRoute redirectPath={`/${paths.issues.master}`} />
            }
          >
            <Route index element={<ListSLAs />} />
          </Route>
        </Route>

        <Route path={`/${paths.settings.index}/${paths.issueTypes.index}`}>
          <Route path={`${paths.issueTypes.add}`} element={<IssueTypeForm />} />
          <Route
            path={`${paths.issueTypes.edit}`}
            element={<IssueTypeForm />}
          />
        </Route>

        <Route path={`/${paths.settings.index}/${paths.issueTemplates.index}`}>
          <Route path=':slug' element={<IssueTemplateForm />} />
          <Route
            path={`${paths.issueTemplates.add}`}
            element={<IssueTemplateForm />}
          />
        </Route>
      </Route>

      <Route
        path={`/${paths.issueTemplates.index}`}
        element={<TypeManagerRoute redirectPath={`/${paths.issues.master}`} />}
      >
        <Route path=':slug' element={<IssueTemplateForm />} />
        <Route
          path={paths.issueTemplates.add}
          element={<IssueTemplateForm />}
        />
      </Route>
      {/* Shared Components Test Page - RCP-31750: Feature-flagged version testing */}
      <Route
        path={`/${paths.sharedComponentsTest}`}
        element={<FeatureFlagRoute featureFlag='sharedComponentsTestPage' />}
      >
        <Route index element={<SharedComponentsTest />} />
      </Route>

      <Route path={`/${paths.error}`} element={<ErrorPage />} />
      <Route path='*' element={<NotFoundRoute />} />
    </Routes>
  );
}
